export default __webpack_public_path__ + "static/media/alice.0c731870.jpg";